/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { syncStatusResponseSchema } from './syncStatusResponseSchema';

export const pageResponseSyncStatusResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(syncStatusResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
